import { Box, Button, Container, createTheme, CssBaseline, Stack, ThemeProvider, useTheme } from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { Outlet } from "react-router";
import TitleBar from "./layout/TitleBar";

const DarkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: blue[300],
      contrastText: grey[50]
    }
  }
});

const LightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: blue[500],
      contrastText: grey[900]
    }
  }
});

const Layout: React.FC = () => {
  const theme = useTheme();
  const [lightMode, setLightMode] = useState<boolean>(false);

  const auth = useAuth();

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.isAuthenticated == false || auth.error) {
    auth.signinRedirect()
  }

  if (auth.isAuthenticated) {
    return (
      <ThemeProvider theme={lightMode ? LightTheme : DarkTheme}>
        <CssBaseline />
        <TitleBar lightMode={lightMode} setLightMode={setLightMode} />
        <Box sx={{ display: " flex" }}>
          <Container maxWidth={false} disableGutters sx={{ marginTop: 10 }}>
            <Outlet />
          </Container>
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <Container>
    </Container>
  );
}

export default Layout;
